import Aos from 'aos';
import { useEffect } from 'react'

const SolarFinancingVideos = () => {
    useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
    return (
        <section className="video-section" data-aos="fade-up" data-aos-duration="1000">
            <h2 className="video-heading" data-aos="fade-down" data-aos-delay="200">Watch Videos</h2>

            <div className="video-grid">
                <div className="video-wrapper" data-aos="zoom-in" data-aos-delay="400">
                    <iframe
                        src="https://www.youtube.com/embed/eYQrd7X5898?rel=0"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen>
                    </iframe>
                </div>

                <div className="video-wrapper" data-aos="zoom-in" data-aos-delay="600">
                    <iframe
                        src="https://www.youtube.com/embed/Et5GQ7ClY04?rel=0"
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen>
                    </iframe>
                </div>
            </div>

            <div className="see-more-container" data-aos="fade-up" data-aos-delay="800">
                <a
                    href="https://www.youtube.com/@CheckoffFinance"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="see-more-link"
                >
                    Click to see more →
                </a>
            </div>
        </section>
    )
}

export default SolarFinancingVideos